<div style="max-height: 800px;overflow-y: hidden;" class="customer-details-card p-20 "
 >

    <app-card cardTitle="{{'attachments' | translate}}" [padding]="20">
        <ng-template #headerOptionsTemplate>
            <a href="javascript:" class="text-muted" mat-dialog-close>
                <i class="ti ti-x f-20"></i>
            </a>
        </ng-template>
        <div class="personal-details">
            <div class="row">
                <form [formGroup]="demoForm">
                    <file-upload #fileUpload formControlName="files" style="min-height: 200px; outline: 2px dashed #adadad"
                        class-="new-file"></file-upload>
                </form>
            </div>

            <div mat-dialog-content style="max-height: 400px;" class="row">
                @for (task of attachedFiles; track task) {
                <div class="col-6">
                    <app-card [showHeader]="false">
                        <div class="flex">
                            <div class="flex-shrink-0 m-r-15">
                                <svg class="wid-40 hei-40 text-warning-500">
                                    <use xlink:href="assets/fonts/custom-icon.svg#custom-folder-open"></use>
                                </svg>
                            </div>
                            <div class="flex-grow-1 m-r-15">
                                <div class="m-b-8 f-16 f-w-600 grid"><span class="text-truncate w-100">{{ task.name
                                        }}</span></div>
                                <p class="m-b-0"><small>{{ task.ext }}</small></p>
                            </div>
                            <a href="javascript:" class="avatar avatar-xs text-warn-500" matTooltip="Download"
                                (click)="download(task)">
                                <i class="ti ti-download f20"></i>
                            </a>
                            <a href="javascript:" class="avatar avatar-xs text-warn-500" matTooltip="Delete"
                                (click)="delete(task.id)">
                                <i class="ti ti-trash f-18"></i>
                            </a>

                        </div>
                    </app-card>
                </div>
                }
            </div>

            <div class="file-footer">
                <div class="text-end">
                    <button mat-flat-button color="accent" class="m-r-10" mat-dialog-close>{{'close' | translate}}</button>
                    <button mat-flat-button color="primary" (click)="onFileSelected($event)" >{{'addFiles' | translate}}</button>
                </div>
            </div>

        </div>

    </app-card>

</div>